<template>
    <div>
        <van-nav-bar placeholder fixed>
            <template #left>
                <van-icon @click="goback" name="arrow-left" size="22" color="#000" />
            </template>
        </van-nav-bar>
        <div class="boy">
            <div class="boy_top">
                <div class="boy_left">
                    <el-image v-if="zhanshiinfo.avatar" class="uimg" :src="zhanshiinfo.avatar" alt=""
                        srcset=""></el-image>
                    <div class="boy_right">
                        <div class="uname">{{ zhanshiinfo.nickname }}</div>
                        <div class="z_flex bom" v-if="nowUserInfo.userID != 'xj1'">
                            <div>ip：{{ zhanshiinfo.city }}</div>
                        </div>
                    </div>
                </div>
                <div class="z_flex">
                    <img v-if="ishaoyou" src="../../assets/tim/q.png" alt="" srcset="" @click="handlerHaoyou(1)">
                    <img v-else src="../../assets/tim/j.png" alt="" srcset="" @click="handlerHaoyou(2)">
                </div>
            </div>
            <div class="js" v-if="nowUserInfo.userID != 'xj1'">
                <div style="width: 90px;">业务介绍：</div>
                <div style="flex: 1;">{{ zhanshiinfo.zyyw_content }}</div>
            </div>
            <div class="wuliu" v-if="nowUserInfo.userID != 'xj1'">
                <div style="width: 80px;">支持物流：</div>
                <div class="wuliur">
                    <div v-for="(item, index) in zhanshiinfo.logistics_names" :key="index">
                        <span style="margin: 10px;">{{ item }}</span>
                    </div>
                </div>
            </div>
            <div class="btnsflex">
                <!-- <div class="btn_detail" @click="goDetail()" v-if="nowUserInfo.userID != 'xj1'">
                    查看详情
                </div> -->
                <div class="btn" @click.stop="gohuihuaNow()">
                    在线咨询
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getSupplierDetail, jhaoyou, shaoyou } from '@/api/index.js'
export default {
    name: '',
    data() {
        return {
            ishaoyou: false,
            nowUserInfo: {},
            zhanshiinfo: {}
        }
    },
    mounted() {
        this.nowUserInfo = JSON.parse(localStorage.getItem('hyinfo') )
        let toid = this.nowUserInfo.profile.userID.substring(2)
        this.isFriend(this.nowUserInfo.profile.userID)
        getSupplierDetail({ supplier_id: toid }).then(res => {
            if (res.code == 1) {
                this.zhanshiinfo = res.data
                this.loading = false
            }
        })
    },
    methods: {
        //查看详情
        goDetail() {
            //如果当前就在详情页 并且与要跳转的id一直就直接关闭弹窗
            this.$router.push({ path: "/gydetail", query: { id: this.zhanshiinfo.id } })
        },
        //去聊天
        gohuihuaNow() {
            let obj = {
                userProfile:this.nowUserInfo.profile
            }
            this.$router.push({ path: "/indexdetail",query:obj }).catch(() => { });
            
        },
        //检测是否是好友
        isFriend(userID) {
            let that = this
            let promise = that.tim.checkFriend({
                userIDList: [userID],
                type: that.TIM.TYPES.SNS_CHECK_TYPE_SINGLE,
            });
            promise.then(function (imResponse) {
                const { successUserIDList, failureUserIDList } = imResponse.data;
                if (successUserIDList[0].relation == 'CheckResult_Type_AWithB') {
                    that.ishaoyou = true
                } else {
                    that.ishaoyou = false
                }
            }).catch(function (imError) {
                console.warn('checkFriend error:', imError);
            });
        },
        handlerHaoyou(type) {
            let that = this
            if (type == 1) {
                let promise = that.tim.deleteFriend({
                    userIDList: [this.nowUserInfo.profile.userID],
                    type: that.TIM.TYPES.SNS_DELETE_TYPE_BOTH
                });
                promise.then(function (imResponse) {
                    that.ishaoyou = false
                    shaoyou({ collect_id: this.nowUserInfo.profile.userID.substring(2) }).then(res => {
                        console.log(res);
                    })
                }).catch(function (imError) {
                    console.warn('removeFromFriendList error:', imError);
                });

            } else {
                let promise = that.tim.addFriend({
                    to: this.nowUserInfo.profile.userID,
                    source: 'AddSource_Type_Web',
                    type: that.TIM.TYPES.SNS_ADD_TYPE_SINGLE
                });
                promise.then(function (imResponse) {
                    that.ishaoyou = true
                    jhaoyou({ collected_id: this.nowUserInfo.profile.userID.substring(2) }).then(res => {
                        console.log(res);
                    })
                }).catch(function (imError) {
                    console.warn('removeFromFriendList error:', imError);
                });
            }
        },
        goback() {
            this.$router.go(-1)
        },
    },
}
</script>
<style lang='scss' scoped>
.boy {
    width: 100%;
    padding: 20px 16px;
    box-sizing: border-box;
}

.z_flex {
    display: flex;
    align-items: center;
}

.boy_top {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .boy_left {
        display: flex;
        align-items: center;

        .uimg {
            width: 60px;
            height: 60px;
            border-radius: 30px;
        }

        .boy_right {
            margin-left: 30px;

            img {
                width: 24px;
                height: 24px;
                cursor: pointer;
            }

            .uname {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 20px;
                color: #000000;
                line-height: 28px;
            }

            .bom {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                color: #757575;
                line-height: 19px;
                margin-top: 6px;
            }
        }
    }


}

.js {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    line-height: 19px;
    margin-top: 24px;
    display: flex;
    flex-wrap: wrap;

}

.wuliu {
    display: flex;
    margin-top: 10px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #E38111;
    line-height: 19px;

    .wuliur {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
    }
}

.imglist {
    display: flex;
    justify-items: center;
    margin-top: 24px;

    img {
        width: 220px;
        height: 200px;
        border-radius: 10px 10px 10px 10px;
        margin-right: 10px;
    }
}

.btnsflex {
    display: flex;
    justify-content: center;
    margin-top: 40px;
}

.btn {
    width: 160px;
    height: 50px;
    background: #FFDB0C;
    border-radius: 10px 10px 10px 10px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    line-height: 50px;
    text-align: center;
}

.btn_detail {
    width: 160px;
    height: 48px;
    background: #F7F8FA;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #ADAAAA;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    line-height: 50px;
    text-align: center;
    cursor: pointer;
    margin-right: 40px;

}

.btn:hover {
    background: #FFED86 !important;
    cursor: pointer;
}
</style>